
import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const PlansPage = lazy(() => import('../pages/plans/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const NutriBotPage = lazy(() => import('../pages/nutribot/page'));
const SignInPage = lazy(() => import('../pages/auth/signin/page'));
const SignUpPage = lazy(() => import('../pages/auth/signup/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
// add forgot and legal pages
const ForgotPage = lazy(() => import('../pages/auth/forgot/page'));
const TermsPage = lazy(() => import('../pages/legal/terms/page'));
const PrivacyPage = lazy(() => import('../pages/legal/privacy/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/plans',
    element: <PlansPage />,
  },
  {
    path: '/nutribot',
    element: <NutriBotPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/signin',
    element: <SignInPage />,
  },
  {
    path: '/signup',
    element: <SignUpPage />,
  },
  {
    path: '/forgot',
    element: <ForgotPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
